// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiple-select-big > div {\n  height: 120px;\n  overflow: auto;\n}\n\n.multiple-select-med > div {\n  height: 80px;\n  overflow: auto;\n}\n\n.adhoc-report-badge > .ant-badge-count {\n  height: 18px;\n  width: 12px;\n  line-height: 18px;\n  font-size: 10px;\n}\n\n.adhoc-report-date-picker .ant-calendar-today .ant-calendar-date {\n  color: inherit;\n  font-weight: inherit;\n  border-color: white;\n}\n\n.ar-causecode .ant-select-remove-icon {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
